module.exports = __webpack_public_path__ + "img/bg.dfa5ea0c.png";